import InputField from '@/components/fields/InputField';
import TitleField from '@/components/fields/TitleField';
import DaysField from '@/components/fields/DaysField';
import MonthsField from '@/components/fields/MonthsField';
import YearsField from '@/components/fields/YearsField';
import DateField from '@/components/fields/DateField';
import GenderField from '@/components/fields/GenderField';
import CountryField from '@/components/fields/CountryField';
import RadioField from '@/components/fields/RadioField';
import CheckboxField from '@/components/fields/CheckboxField';
import MedicalConditionsField from '@/components/fields/MedicalConditions';
import DisqualificationField from '@/components/fields/Disqualification';
import PostCodeField from '@/components/fields/PostCodeField';
import SelectField from '@/components/fields/SelectField';
import TextAreaField from '@/components/fields/TextAreaField';

export const Input = InputField;
export const Title = TitleField;
export const Days = DaysField;
export const Months = MonthsField;
export const Years = YearsField;
export const Date = DateField;
export const Gender = GenderField;
export const Country = CountryField;
export const Radio = RadioField;
export const Checkbox = CheckboxField;
export const MedicalConditions = MedicalConditionsField;
export const Disqualification = DisqualificationField;
export const PostCode = PostCodeField;
export const Select = SelectField;
export const TextArea = TextAreaField;
